var parseTranslationsAndLanguageKey = function (translationResponseObject, domain) {
    var translationObject = {};
    for (var languageKey in translationResponseObject.translations) {
        if (translationResponseObject.translations.hasOwnProperty(languageKey)) {
            if (domain === 'messages') {
                translationObject[languageKey] = translationResponseObject.translations[languageKey].messages;
            }
            else {
                var domainMessages = translationResponseObject.translations[languageKey][domain];
                for (var messageKey in domainMessages) {
                    if (domainMessages.hasOwnProperty(messageKey)) {
                        var messageValue = domainMessages[messageKey];
                        delete domainMessages[messageKey];
                        domainMessages[domain + '.' + messageKey] = messageValue;
                    }
                }
                translationObject[languageKey] = domainMessages;
            }
        }
    }
    return translationObject;
};
var TranslationResponseMapper = /** @class */ (function () {
    function TranslationResponseMapper() {
    }
    TranslationResponseMapper.map = function (translationResponseObject, domain) {
        if (domain === void 0) { domain = 'messages'; }
        if (translationResponseObject === null) {
            return null;
        }
        return parseTranslationsAndLanguageKey(translationResponseObject, domain);
    };
    return TranslationResponseMapper;
}());
export default TranslationResponseMapper;
